import { useCallback } from 'react';
import { App } from 'antd';

// 消息配置接口
interface MessageConfig {
  content: string;
  duration?: number;
  onClose?: () => void;
}

// 自定义 message hook - 使用 App.useApp() 替代静态方法
export const useMessage = () => {
  const { message } = App.useApp();

  const success = useCallback(
    (config: string | MessageConfig) => {
      const normalizedConfig = typeof config === 'string' ? { content: config } : config;
      return message.success(normalizedConfig);
    },
    [message]
  );

  const error = useCallback(
    (config: string | MessageConfig) => {
      const normalizedConfig = typeof config === 'string' ? { content: config } : config;
      return message.error(normalizedConfig);
    },
    [message]
  );

  const warning = useCallback(
    (config: string | MessageConfig) => {
      const normalizedConfig = typeof config === 'string' ? { content: config } : config;
      return message.warning(normalizedConfig);
    },
    [message]
  );

  const info = useCallback(
    (config: string | MessageConfig) => {
      const normalizedConfig = typeof config === 'string' ? { content: config } : config;
      return message.info(normalizedConfig);
    },
    [message]
  );

  const loading = useCallback(
    (config: string | MessageConfig) => {
      // loading 类型默认 duration=0（永不自动关闭），需手动调用返回的 hide 函数
      const normalizedConfig = typeof config === 'string'
        ? { content: config, duration: 0 }
        : { duration: 0, ...config };
      return message.loading(normalizedConfig);
    },
    [message]
  );

  const destroy = useCallback(() => {
    return message.destroy();
  }, [message]);

  return {
    success,
    error,
    warning,
    info,
    loading,
    destroy,
  };
};

export default useMessage;
